module.exports = __webpack_public_path__ + "static/media/whatsapp.2fc1a039.svg";